/*
    价格历史
 */

const PriceHistory = {

    /**
     * 获取价格历史
     * @param dp_id
     * @param days
     * @param get_coupon
     * @param price
     * @param show_prom
     * @param from
     * @return {Promise}
     */
    get (dp_id, days = '', get_coupon = 0, price='', show_prom=0, from = '') {
        let data = {
            dp_id: dp_id,
            get_coupon: get_coupon,
            v: 2,
        };

        if (days) data.days = days;
        if (price) data.price = price;
        if (show_prom) data.show_prom = 1;

        return new Promise((resolve) => {
            $.ajax({
                url: '/trend/data_www/',
                dataType:'json',
                data: data,
                success (res) {
                    if (res && res.is_ban !== undefined && res.is_ban == 1) {
                        window.location.href = res.action.to;
                        return;
                    }
                    resolve(res)
                },
            })
        });
    },

    getPriceStatus (status) {
        const map = {
            0: '价格平稳',
            1: '价格上涨',
            '-1': '价格下降',
            '-2': '历史最低'
        };

        return map[status];
    },
};

export default PriceHistory;
